




/**
 * @file PDFのダウンロードリストを取得するコンポーネント
 */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Conditions } from '../../modules/class/PdfDownload/Conditions'
import { DownloadLinkInfo, sortPdf } from '../../modules/class/Downloads'
import { PageMap, Site, SitePageMap } from '../../modules/class/PageList'
import { downloadState } from '../../store/modules/DownloadState'

@Component({
  components: {}
})
export default class PdfList extends Vue {
  @Prop() private conditions!: Conditions

  // -------------------------------------------------------------------------------------------------------------------
  // computed

  /**
   * 対象となるPDFのマップ
   */
  get pageMap(): SitePageMap {
    let map: SitePageMap = new Map()
    if (!this.conditions.source) {
      return map
    }

    // PDF一覧を取得
    switch (this.conditions.source) {
      case 'product':
        map = downloadState.productPageMap
        break
      case 'industry':
        map = downloadState.industryPageMap
        break
      case 'industry_category':
        map = downloadState.industryCategoryPageMap
        break
      case 'case':
        map = downloadState.casePageMap
        break
    }

    return map
  }

  /**
   * 表示するPDF一覧（自サイト）
   */
  get currentPdfList(): DownloadLinkInfo[] {
    const site = drupalSettings.vueComponent.sites.current
    return this.filterPdfList(this.pageMap, site)
  }

  /**
   * 表示する他サイトのPDF一覧
   */
  get otherSitePdfList(): DownloadLinkInfo[] {
    let list: DownloadLinkInfo[] = []
    for (const site of drupalSettings.vueComponent.sites.pageListSites) {
      list = list.concat(this.filterPdfList(this.pageMap, site))
    }
    // 他サイト内でソート
    list.sort(sortPdf)
    return list
  }

  private filterPdfList(map: SitePageMap, site: Site): DownloadLinkInfo[] {
    // サイトと絞り込み対象のIDからページMapを取得
    const pageMap =
      this.pageMap.get(site.code)?.get(this.conditions.key) ??
      (new Map() as PageMap)

    // map型をObject型へ変換
    let pages = [...pageMap.values()]

    // disableを除外
    pages = pages.filter(
      (page) =>
        !page.disabledSites.includes(
          drupalSettings.vueComponent.sites.current.code
        )
    )

    // 表示種別でフィルタ
    if (this.conditions.filterTypes.length > 0) {
      pages = pages.filter((page) =>
        this.conditions.filterTypes.includes(page.contentTypeCode)
      )
    }

    // 一覧をソート
    pages.sort(sortPdf)

    // 最大表示件数で絞り込む(0は全件)
    if (this.conditions.max > 0) {
      pages = pages.slice(0, this.conditions.max)
    }

    return pages
  }

  // -------------------------------------------------------------------------------------------------------------------
  // watcher

  /**
   * 抽出条件のデータに変更があったタイミングでページ一覧を取得（通常は１回）
   */
  @Watch('conditions')
  fetchPageMap(): void {
    // PDF一覧を取得
    switch (this.conditions.source) {
      case 'product':
        downloadState.fetchProductPageMap()
        break
      case 'industry':
        downloadState.fetchIndustryPageMap()
        break
      case 'industry_category':
        downloadState.fetchIndustryCategoryPageMap()
        break
      case 'case':
        downloadState.fetchCasePageMap()
        break
    }
  }

  @Watch('pageMap')
  changePdfList(): void {
    // 自サイトのリスト取得
    let pdfList = this.currentPdfList

    // 親サイトのリスト取得
    pdfList = pdfList.concat(this.otherSitePdfList)

    this.$emit('fetchPdf', pdfList)
  }
}
